import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
//pass new generated access token here

//apply base url for axios
const API_URL = process.env.REACT_APP_BASEURL;

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);

toastr.options = {
  timeOut: 5000,
  progressBar: true,
};

const handleError = response => {
  console.log("ERROR OCCOR : ", response);
  if (typeof response !== "undefined") {
    let data = response["data"];
    let status = response["status"];

    if (status === 422) {
      if (Array.isArray(data.errors)) {
        data.errors.forEach(text => toastr.error(`${text}`, "خطا"));
      } else if (typeof data.errors == "object") {
        let er = [];
        Object.values(data.errors).forEach(e => er.push(e));
        toastr.error(`${er.join(" - ")}`, "خطا");
      } else {
        toastr.error(`${data.errors}`, "خطا");
      }
    }
    if (status === 500) {
      if (data.errors) {
        toastr.error(`${data.errors}`, "خطا");
        setTimeout(() => {
          window.location = "/pages-500";
        }, 4000);
      } else {
        toastr.error(`خطایی سمت سرور رخ داده است`, "خطا");
        setTimeout(() => {
          window.location = "/pages-500";
        }, 4000);
      }
    }
    if (status === 401) {
      localStorage.removeItem("authUser");
      toastr.error("خطایی امنیتی رخ داده است لطفا دباره وارد شوید", "خطا");
      console.log("IM FIRE 401");
      setTimeout(() => {
        window.location = "/login";
      }, 4000);
    }
    if (status === 400) {
      console.log("IM FIRE 400");
      toastr.error("خطایی امنیتی رخ داده است لطفا دباره وارد شوید", "ERROR");
    }
  }
};

export const get = async (
  url,
  config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  }
) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).access_token
      : ""
  }`;
  return await axiosApi
    .get(url, { ...config })
    .then(response => {
      if (response && response.data) {
        return response.data;
      } else {
        handleError(response, response.statusCode);
        return { status: false };
      }
    })
    .catch(error => {
      handleError(error.response);
    });
};

export const post = async (url, data, config = {}) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).access_token
      : ""
  }`;
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => {
      if (response && response.data) {
        return response.data;
      } else {
        handleError(response, response.statusCode);
        return { status: false };
      }
    })
    .catch(error => {
      handleError(error.response);
    });
};

export const put = async (url, data, config = {}) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).access_token
      : ""
  }`;
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data);
};

export const del = async (url, config = {}) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).access_token
      : ""
  }`;
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(error => {
      handleError(error.response);
    });
};

const CustomPost = (url, params = {}, skip) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).access_token
      : ""
  }`;
  return new Promise((resolve, reject) => {
    axiosApi
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        handleError(error.response);
        reject(error && error.response && error.response.data);
      });
  });
};

const API = {
  common: {
    auth: {
      getToken: async (params = {}) => {
        return await post("admin/getToken", params);
      },
      login: (params = {}) => {
        return post("admin/login", params);
      },
    },
    info: () => {
      return get(`user/user/info`);
    },
    userUpdate: (params = {}) => {
      return CustomPost(`user/user/update_profile`, params);
    },
  },
  user: {
    list: (params = {}) => {
      return get("admin/list/user");
    },
    delete: id => {
      return get(`admin/delete/user?user_id=${id}`);
    },
    add: (params = { name: "", mobile: "", email: "", type: "admin" }) => {
      return post("admin/add/user", params);
    },
    edit: (params = { name: "", mobile: "", email: "", type: "admin" }) => {
      return post("admin/edit/user", params);
    },
  },
  slider: {
    list: (params = {}) => {
      return get("admin/list/slider");
    },
    delete: id => {
      return get(`admin/delete/slider?slider_id=${id}`);
    },
    add: params => {
      return CustomPost("admin/add/slider", params);
    },
    edit: (params = {}) => {
      return CustomPost("admin/edit/slider", params);
    },
    editVideo: (params = {}) => {
      return CustomPost("/admin/edit/video/slider", params);
    },
    delVideo: id => {
      return get(`/admin/delete/video/slider?id=${id}`);
    },
  },
  social: {
    list: (params = {}) => {
      return get("admin/list/social");
    },
    delete: id => {
      return get(`admin/delete/social?social_id=${id}`);
    },
    add: (params = { name: "", mobile: "", email: "", type: "admin" }) => {
      return CustomPost("admin/add/social", params);
    },
    edit: (params = { name: "", mobile: "", email: "", type: "admin" }) => {
      return CustomPost("admin/edit/social", params);
    },
  },
  products: {
    list: (params = {}) => {
      return get("admin/product/list");
    },
    delete: id => {
      return get(`admin/product/delete?product_id=${id}`);
    },
    add: params => {
      return CustomPost("admin/product/add", params);
    },
    edit: params => {
      return CustomPost("admin/product/edit", params);
    },
    addSpecific: params => {
      return CustomPost("admin/add/specific", params);
    },
    deleteSpecific: id => {
      return get(`admin/delete/specific?id=${id}`);
    },
    deletePic: id => {
      return get(`admin/product/images/delete?id=${id}`);
    },
  },
  aboutUs: {
    list: (params = {}) => {
      return get("admin/list/about");
    },
    add: params => {
      return CustomPost("admin/add/about", params);
    },
    edit: params => {
      return CustomPost("admin/edit/about", params);
    },
  },
  contactUs: {
    list: (params = {}) => {
      return get("admin/list/contact");
    },
    add: params => {
      return CustomPost("admin/add/contact", params);
    },
    edit: params => {
      return CustomPost("admin/edit/contact", params);
    },
  },
  category: {
    list: (params = {}) => {
      return get("admin/main/category/list");
    },
    delete: id => {
      return get(`admin/main/category/delete?category_id=${id}`);
    },
    add: params => {
      return CustomPost("admin/main/category/add", params);
    },
    edit: params => {
      return CustomPost("admin/main/category/edit", params);
    },
  },
  news: {
    list: (params = {}) => {
      return get("admin/list/news");
    },
    delete: id => {
      return get(`admin/delete/news?news_id=${id}`);
    },
    add: params => {
      return CustomPost("admin/add/news", params);
    },
    edit: params => {
      return CustomPost("admin/edit/news", params);
    },
  },
  userComment: {
    list: (params = {}) => {
      return get("admin/list/comment");
    },
    delete: id => {
      return get(`admin/delete/comment?comment_id=${id}`);
    },
    edit: params => {
      return CustomPost("admin/edit/comment", params);
    },
  },
  flags: {
    list: (params = {}) => {
      return get("admin/list/icon?type=flag");
    },
    delete: id => {
      return get(`admin/delete/icon?id=${id}`);
    },
    edit: params => {
      return CustomPost("admin/edit/icon", params);
    },
    add: params => {
      return CustomPost("admin/add/icon", params);
    },
  },
  brands: {
    list: (params = {}) => {
      return get("admin/list/icon?type=brands");
    },
    delete: id => {
      return get(`admin/delete/icon?id=${id}`);
    },
    edit: params => {
      return CustomPost("admin/edit/icon", params);
    },
    add: params => {
      return CustomPost("admin/add/icon", params);
    },
  },
  catalog: {
    list: (params = {}) => {
      return get("admin/list/catalog");
    },
    delete: id => {
      return get(`admin/delete/catalog?catalog_id=${id}`);
    },
    edit: params => {
      return CustomPost("admin/edit/catalog", params);
    },
    add: params => {
      return CustomPost("admin/add/catalog", params);
    },
  },
  email: () => {
    return get("admin/list/email");
  },
};

export default API;
